import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const SortNeutral = (props: SvgIconT.Props) => (
  <SvgIcon {...props} viewBox="0 0 20 20">
    <path d="M 15 9 H 5 l 5 -5 z M 10 16 L 5 11 h 10 z"></path>
  </SvgIcon>
);

export default SortNeutral;
